module.exports = __webpack_public_path__ + "static/media/f3c167b5-83d0-4b75-8f27-b74c7d82206a.f896434a.JPG";